import axios from 'axios'

var host = process.env.VUE_APP_API_HOST

export const dripServices = {
  getDripEnrollmentPage,
  getUserIsEnrolled,
  enrollUser,
  manuallyEnrollUser,
  unEnrollUser,
  removeUserEnrollment,
  createDrip,
  getDrip,
  updateDrip,
  deleteDrip,
  getActiveDrips,
  getDrips,
  setActive,
  getEnrolledDripUserList,
  getFirstActivityId,
  getActivityPage,
  getDripActivityMenu,
  setDripActivityComplete,
  getDripUserEnrollmentDetail,
  getUserEnrolledDrips,
  sendFirstNotification,
  getDripMessageThreadForUser,
  getDripMessageThreadForAdmin,
  getUsersDripMessageCount,
  clearUserNotViewedCount,
  clearAdminNotViewedCount,
  saveDripMessage
}

function getDripEnrollmentPage (clientId, dripCode) {
  return new Promise(function (resolve, reject) {
    axios
      .get(`${host}/api/drip/${dripCode}/client/${clientId}`)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getUserIsEnrolled (dripId) {
  return new Promise(function (resolve, reject) {
    axios
      .get(`${host}/api/drip/${dripId}/enrollmentStatus`)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function enrollUser (dripId, questions) {
  return new Promise(function (resolve, reject) {
    var registration = {
      dripId: dripId,
      questions: questions
    }
    return axios
      .post(`${host}/api/drip/${dripId}/enrollment`, registration)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        console.log('Enrollment Error: ', err)
        reject(err)
      })
  })
}

function manuallyEnrollUser (dripId, email) {
  return new Promise(function (resolve, reject) {
    var registration = {
      dripId: dripId,
      userEmail: email
    }
    return axios
      .post(`${host}/api/drip/${dripId}/enrollment/user`, registration)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        // console.log('ERROR: ' + JSON.stringify(err.response))
        reject(err.response)
      })
  })
}

function unEnrollUser (dripId) {
  return new Promise(function (resolve, reject) {
    return axios
      .delete(`${host}/api/drip/${dripId}/enrollment`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Enrollment Error: ', err)
        reject(err)
      })
  })
}

function removeUserEnrollment (dripId, userId) {
  return new Promise(function (resolve, reject) {
    return axios
      .delete(`${host}/api/drip/${dripId}/enrollment/user/${userId}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Enrollment Error: ', err)
        reject(err)
      })
  })
}

function createDrip (drip) {
  return axios
    .post(`${host}/api/drip/`, drip)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getDrip (code) {
  return axios
    .get(`${host}/api/drip/${code}`)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function updateDrip (drip) {
  return axios
    .put(`${host}/api/drip/${drip.code}`, drip)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function deleteDrip (dripCode) {
  return axios
    .delete(`${host}/api/drip/${dripCode}`)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getActiveDrips (clientId) {
  return axios
    .get(`${host}/api/drip/client/${clientId}`)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getDrips () {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/drip/`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function setActive (id, active) {
  return new Promise(function (resolve, reject) {
    console.log(id, active)
    return axios
      .post(`${host}/api/drip/${id}/active`, { active })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getEnrolledDripUserList (code) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/drip/${code}/users`)
      .then(response => {
        // console.log('Event Users: ' + response.data)
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

// Gets all the Drips where the current user is enrolled
function getUserEnrolledDrips () {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/drip/user/enrolled`)
      .then(response => {
        // console.log('Event Users: ' + response.data)
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getFirstActivityId (dripCode) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/drip/${dripCode}/activity`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getActivityPage (dripCode, activityId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/drip/${dripCode}/activity/${activityId}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getDripActivityMenu (dripCode) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/drip/${dripCode}/activity/menu`)
      .then(response => {
        console.log('Menu: ', response.data)
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function setDripActivityComplete (dripCode, activityId, completed) {
  return new Promise(function (resolve, reject) {
    var dripActivity = {
      ActivityId: activityId,
      Code: dripCode,
      Completed: completed
    }
    console.log('Setting Drip Activity Complete: ', dripActivity)
    return axios
      .post(`${host}/api/drip/activity/completed`, dripActivity)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Set Activity Complete Error: ', dripActivity)
        console.log(err)
        reject(err)
      })
  })
}

function getDripUserEnrollmentDetail (dripCode, userId) {
  console.log('Attempting getEventUserEnrollmentDetail')
  console.log(`${host}/api/drip/${dripCode}/user/${userId}/detail`)
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/drip/${dripCode}/user/${userId}/detail`)
      .then(response => {
        // console.log('data: ' + JSON.stringify(response.data))
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function sendFirstNotification (dripCode) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/drip/${dripCode}/first/notification`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getDripMessageThreadForUser (dripCode) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/dripMessage/thread/${dripCode}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getDripMessageThreadForAdmin (dripCode, targetUserId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/dripMessage/thread/${dripCode}/${targetUserId}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function clearUserNotViewedCount (dripCode) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/dripMessage/thread/${dripCode}/viewed`)
      .then(() => {
        resolve()
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function clearAdminNotViewedCount (dripCode, targetUserId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/dripMessage/thread/${dripCode}/${targetUserId}/viewed`)
      .then(() => {
        resolve()
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getUsersDripMessageCount (dripCode) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/dripMessage/${dripCode}/users`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function saveDripMessage (dripCode, message) {
  return new Promise(function (resolve, reject) {
    var post = {
      userIdThread: message.userIdThread,
      // userId: message.userId,
      message: message.message,
      photoList: message.photos.join('|')
    }
    return axios
      .post(`${host}/api/dripMessage/${dripCode}`, post)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}
